import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const InProgressIcon16 = (props: SvgProps) => <Svg
  width='11'
  height='12'
  viewBox='0 0 11 12'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M8.5 5.99999L2 2.24722L2 9.75277L8.5 5.99999ZM10 6.86602C10.6667 6.48112 10.6667 5.51887 10 5.13397L2 0.515166C1.33333 0.130266 0.5 0.61139 0.5 1.38119L0.5 10.6188C0.5 11.3886 1.33333 11.8697 2 11.4848L10 6.86602Z'
    fill='#003A70'
  />
</Svg>;

export default InProgressIcon16;
